import React from "react"
import {useLocal, useLightbox} from "../../AppContext"
import style from "./Product.css"
import {productColorOptionIds} from "../../settings"
import {iconCrown, iconGallery} from "../../Helper/Icons"

export const Product = ({product, setProduct, isCurrent, onSelect, selector}) => {
    const className = isCurrent
        ? `${style.item} ${style.active}`
        : style.item

    const onClick = () => {
        onSelect(product)
    }

    return <div className={className} onClick={onClick}>
        <Image product={product} setProduct={setProduct} selector={selector}/>
        <div className={style.info}>
            <div>
                <Name product={product}/>
                <Premium product={product}/>
                <Sku product={product}/>
                <UnitCount product={product}/>
            </div>
            <div>
                <ColorCount product={product}/>
                <ColorList product={product}/>
            </div>
        </div>
    </div>
}

const Image = ({product, setProduct, selector}) => {
    const lightbox = useLightbox()

    let productImageUrl = product.imageUrl;
    if (product.mountingImageFloorUrl && selector.isToFloor()) {
        productImageUrl = product.mountingImageFloorUrl
    }
    if (product.mountingImageCeilingUrl && selector.isToCeiling()) {
        productImageUrl = product.mountingImageCeilingUrl
    }
    if (product.mountingImageWallUrl && selector.isToWall()) {
        productImageUrl = product.mountingImageWallUrl
    }

    return <div className={style.imageContainer} onClick={() => {setProduct(product); lightbox.openGallery();}}>
        <div className={style.image} style={{backgroundImage: `url('${productImageUrl}')`}}/>
        <div className={style.galleryIcon}>{iconGallery}</div>
    </div>
}

const Name = ({product}) => {
    return <div className={style.name}>{product.name}</div>
}

const Sku = ({product}) => {
    return <div className={style.sku}>{product.sku}</div>
}

const UnitCount = ({product}) => {
    const local = useLocal()
    const variant = Object.values(product.variants)[0]

    return <div className={style.unit}>{local.__("%unitCount% Stück / Packeinheit", {unitCount: variant.unitCount})}</div>
}

const Premium = ({product}) => {
    const local = useLocal()

    if(product.isPremium) {
        return <div className={style.premium}>
            {iconCrown}
            {local.__("Nach der Planung erfolgt automatischer Experten-Check")}
        </div>
    }

    return null;

}

const ColorCount = ({product}) => {
    const local = useLocal()

    if (!product.colorCount) return null

    return <div className={style.colorCount}>{local.__("in %colorCount% Farben erhältlich", {colorCount: product.colorCount})}</div>
}

const ColorList = ({product}) => {
    const colorSwatches = product.configurableOptions
            ?.find(option =>  productColorOptionIds.includes(option.id))
            ?.values.map(value => ({label: value.label, swatchUrl: value.swatch}))

    if(!colorSwatches) return null

    return <div className={style.colorList}>
        {colorSwatches.map((color, index) => {
            return <div key={index} title={color.label} style={{backgroundImage: `url('${color.swatchUrl}')`}}/>
        })}
    </div>
}
